var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('polygon',{attrs:{"points":"17,41.3 43.4,14.9 40.6,12.1 17,35.7 7.4,26.1 4.6,29 ","id":"polygon2","transform":"matrix(0.46479856,0,0,0.46479856,-2.0629777,-3.3181412)"}})}
var staticRenderFns = []

export { render, staticRenderFns }